<template>
    <div 
        class="mb-5"
        :class="[!$breakpoint.smAndDown ? 'card border-radius-top-left-0' : 'border-top']"
    >
        <div 
            class="table-container"
            :class="{'px-3' : $breakpoint.xsOnly}"
        >
            <div 
                class="row mx-0"
                :class="[$breakpoint.smAndDown ? 'pt-2 pb-0' : 'py-3']"
            >
                <div 
                    class="col-xs-12 col-sm-6 col-md-6 d-flex justify-content-start"
                    :class="[$breakpoint.mdAndDown && !$breakpoint.smAndDown ? ' align-items-start' : ' align-items-center', {'px-0' : $breakpoint.xsOnly}]"
                >
                    <h5 class="text-left">
                        <i class="fas fa-inbox mr-2"></i>My Negotiations: {{negotiationSelected.fuel_id | fueltype}}
                    </h5>
                </div>
                <div 
                    class="col-xs-12 col-sm-6 col-md-6"
                    :class="{'px-0' : $breakpoint.xsOnly}"
                >
                    <span class="negotiation-status">
                        <span v-if="negotiationActive" class="countdown">
                            {{timeRemaining | countdownfullformat}}
                            <radial-progress-bar class="countdown-progress" :diameter="40" 
                                :totalSteps="totalCountdownTime" 
                                :completedSteps="timeRemaining" />
                        </span>
                        <span class="d-flex align-items-end flex-column negotiation-status " v-else>
                            <span v-if="negotiationSelected.status_id == 'COMPLETED'" class="static accepted">Accepted</span>
                            <span v-else class="text-danger">
                                <span v-if="negotiationSelected.status_id == 'WITHDRAWN'" class="static withdrawn">Withdrawn</span>
                                <span v-else class="static expired">Expired</span>
                            </span>
                        </span>
                    </span>
                </div>
            </div>
            <table class="table responsive-table">
                <thead>
                    <tr>
                        <th v-if="negotiationType == 'SPOT'">Terminal</th>
                        <th>Vol/L</th>
                        <th>Measurement</th>
                        <th v-if="negotiationType !== 'BUNKERING'">Lifting Period</th>
                        <th>Pricing Method</th>
                        <th>Price (ppl)</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        :class="{'mx-3 w-100' : $breakpoint.mdAndDown && !$breakpoint.xsOnly, 'py-2' : $breakpoint.mdAndDown}"
                    >
                        <td label="Terminal" v-if="negotiationType == 'SPOT'">
                            <span v-if="negotiationSelected.terminal">{{negotiationSelected.terminal.name}}</span>
                            <span v-else>N/A</span>
                        </td>
                        <td label="Vol/L"><span>{{negotiationSelected.quantity | volumeformat}}</span></td>
                        <td label="Measurement"><span>{{negotiationSelected.fuel_measurement_id | fuelmeasurementtype}}</span></td>
                        <td label="Lifting Period" v-if="negotiationType !== 'BUNKERING'"><span>{{negotiationSelected.collectionTime | collectiondaysformat}}</span></td>
                        <td label="Pricing Method"><span>{{negotiationSelected.type_id | offertype}}</span></td>
                        <td label="Price (ppl)">
                            <!-- Check whether calculated live price exceeds the negotiation's max price -->
                            <span>
                                <span>{{negotiationSelected.type_id == 'FIXED' || negotiationSelected.status_id == 'COMPLETED' ?
                                    negotiationSelected.price : negotiationSelected.livePrice | priceformat}}</span>
                                <span v-if="negotiationSelected.type_id == 'TRACKING' && negotiationSelected.status_id !== 'COMPLETED'">(Max: {{negotiationSelected.maxPrice | priceformat}})</span>
                            </span>
                        </td>
                        <td 
                            class="td-actions"
                            :class="{'d-flex justify-content-between' : $breakpoint.mdAndDown}"
                        >
                            <div v-if="negotiationActive" 
                                class="text-right d-flex w-100"
                                :class="[$breakpoint.mdAndDown ? 'justify-content-between' : 'justify-content-end']"
                            >
                                <button class="btn btn-secondary mr-2" @click="reviseNegotiation()">Revise</button>
                                <button class="btn btn-danger" @click="withdrawNegotiation()">Withdraw</button>
                            </div>
                            <div v-else class="text-right">
                                <router-link v-if="negotiationSelected.status_id == 'COMPLETED'" tag="button" class="btn btn-primary" to="/OrderHistory">Order History</router-link>
                                <button v-else class="btn btn-primary w-75" @click="reviseNegotiation()">Re-enter</button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import breakpoint from '@/mixins/index';

export default {
    mixins: [breakpoint],
    data(){
        return {
            timeRemaining: 0,
            countdownFunction: ''
        }
    },
    computed: {
        ...mapState('itemRemoval', ['showItemRemovalConfirmation']),
        ...mapState('negotiation',['negotiationSelected', 'showRenegotiateModal']),
        ...mapState('login',['userLoggedIn']),
        ...mapGetters('fuelsType', ['getFuelsType']),
        ...mapGetters('terminals', ['getTerminalChanges']),
        negotiationType: {
            get: function(){
                if (Object.keys(this.negotiationSelected).length > 0 && this.getFuelsType){
                    return this.getFuelsType.find(fuel => fuel._id == this.negotiationSelected.fuel_id).type
                }
            }
        },
        negotiationActive: { // Return negotiation status
            get: function(){
                if (this.timeRemaining < 1 || 
                    (Object.keys(this.negotiationSelected).length > 0 && this.negotiationSelected.status_id !== 'ACTIVE')){
                    return false
                }
                else {
                    return true
                }
            }
        },
        isAnyCounterAccepted: {
            get: function(){
                if (this.negotiationActive){
                    return false
                }
                else {
                    if (this.negotiationSelected.counterOffers.length > 0){
                        let statuses = []
                        this.negotiationSelected.counterOffers.forEach((counter, index) => statuses.splice(index, 1, counter.status_id))

                        // If any of the counters is accepted, return true
                        if (statuses.indexOf('COMPLETED') !== -1){
                            return true
                        }
                        else {
                            return false
                        }
                    }
                    else {
                        return false
                    }
                }
            }
        },
        performCountdown: function(){
            if (Object.keys(this.negotiationSelected).length > 0){
                if (this.countdownFunction){
                    clearInterval(this.countdownFunction)
                }
                this.timeRemaining = (new Date(this.negotiationSelected.expires) - new Date())/1000
                if (this.timeRemaining > 0){
                    this.countdownFunction = setInterval(()=>{
                            this.timeRemaining --
                            if (this.timeRemaining < 1){
                                clearInterval(this.countdownFunction)
                            }
                        }, 1000)
                }
            }
        },
        totalCountdownTime: {
            get: function(){
                if (Object.keys(this.negotiationSelected).length > 0){
                    return (new Date(this.negotiationSelected.expires) - new Date(this.negotiationSelected.created))/1000
                }
            }
        },
        openModals: function(){
            if (this.showRenegotiateModal){
                let element = this.$root.$refs.renegotiateBuyer.$el
                $(element).modal({backdrop: 'static', keyboard: false})
            }

            if(this.showItemRemovalConfirmation){
                let element = this.$root.$refs.confirmationRemoveItem.$el
                $(element).modal({backdrop: 'static', keyboard: false})
            }
        }
    },
    watch: {
        performCountdown(){},
        openModals(){}
    },
    methods: {
        ...mapActions('itemRemoval', ['openConfirmationRemoval']),
        ...mapActions('negotiation', ['updateShowRenegotiateModal']),
        reviseNegotiation: function(){
            this.updateShowRenegotiateModal(true)
        },
        withdrawNegotiation: function(){
            const payload = {
                item: this.negotiationSelected,
                type: "NEGOTIATION",
                showWindow: true
            };
            this.openConfirmationRemoval(payload);
        }
    },
    beforeDestroy(){
        clearInterval(this.countdownFunction)
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/pages/_negotiations.scss";
</style>